import { toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Cadastrar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppBtn = _resolveComponent("AppBtn")!
  const _component_AuthFormLink = _resolveComponent("AuthFormLink")!
  const _component_DefaultLoading = _resolveComponent("DefaultLoading")!
  const _component_DefaultNotification = _resolveComponent("DefaultNotification")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.displayName) = $event)),
        type: "text"
      }, null, 512), [
        [_vModelText, _ctx.formData.displayName]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.email) = $event)),
        type: "email"
      }, null, 512), [
        [_vModelText, _ctx.formData.email]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event)),
        type: "password"
      }, null, 512), [
        [_vModelText, _ctx.formData.password]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.passwordConfirm) = $event)),
        type: "password"
      }, null, 512), [
        [_vModelText, _ctx.formData.passwordConfirm]
      ]),
      _createVNode(_component_AppBtn, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_AuthFormLink, {
        text: "Já é cadastrado?",
        textLink: "Faça login",
        to: { name: 'Welcome', params: { mode: 'login' } }
      }),
      _createVNode(_component_AuthFormLink, {
        text: "Esqueceu a senha?",
        textLink: "Redefina",
        to: { name: 'Welcome', params: { mode: 'reset' } }
      })
    ], 32),
    _createElementVNode("div", null, [
      (_ctx.isPending)
        ? (_openBlock(), _createBlock(_component_DefaultLoading, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_DefaultNotification, {
        text: _ctx.notification.msg,
        type: _ctx.notification.type
      }, null, 8, ["text", "type"])
    ])
  ]))
}